import axios from "axios"
import React, {Component} from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import ApiHelper from "src/ApiHelper"
import RecommendationCloneCard from "src/components/cards/RecommendationCloneCard"
import RecommendationCard from "../components/cards/RecommendationCard"

class Recommendations extends Component{
    constructor(props){
        super(props)
        this.state = {
            recommendationslist: [],
            searchresults: [],
            recommendationsoffset: 0,
            noofcompanies: props.noofcompanies,
            filter: 0,
            hasMore: true,
            isloadingfinished: false,
            sortby: 0,
            niftyhasloaded: false,
            sensexhasloaded: false,
            mmihasloaded: false,
            niftydata: {},
            sensexdata: {},
            mmidata: {},
        }
    }
    static getDerivedStateFromProps(props, state){
        state.noofcompanies = props.noofcompanies
        return state
    }
    showRecommendations(){
        var rows = []
        for(var i = 0; i < this.state.recommendationslist.length; i++){
            rows.push(<RecommendationCard key={this.state.recommendationslist[i].serialid} noofcompanies={this.state.noofcompanies} recommendation={this.state.recommendationslist[i]}/>)
        }
        return rows
    }
    showSearchResults(){
        var rows = []
        for(var i = 0; i < this.state.searchresults.length; i++){
            rows.push(<RecommendationCard key={this.state.searchresults[i].serialid} recommendation={this.state.searchresults[i]}/>)
        }
        return rows
    }
    render(){
        return <div className="c_recommendations_container c_subcontainers">
            <div className="c_listsettings_container">
                <div className="c_listsetter">
                    Sort By:<br/><select name="sortby" value={this.state.sortby} onChange={this.orderChangeHandler.bind(this)} className="c_select">
                        <option value={0}>ArthScore</option>
                        <option value={1}>Relevance</option>
                        <option value={2}>Target Difference</option>
                        <option value={3}>Alphabetical</option>
                    </select>
                </div>
                <div className="c_listsetter">
                 Filter:<br/><select name="filter" value={this.state.filter} onChange={this.filterChangeHandler.bind(this)} className="c_select">
                    <option value={0}>None</option>
                    <option value={1}>Show Recommendations Only</option>
                </select>
                </div>
            </div>
            <div className="c_subcontent">
                <InfiniteScroll
                    dataLength={this.state.recommendationsoffset}
                    next={this.onRequireFetch.bind(this)}
                    hasMore={this.state.hasMore && this.state.isloadingfinished}
                    loader={<h5>Loading...</h5>}
                    endMessage={this.state.hasMore?<h5>Loading</h5>:<h5>No More Companies To Load</h5>}>
                    {(() => {
                        if(this.state.filter === 1) return ""
                        var clonecards = []
                        clonecards.push(this.state.mmihasloaded?<RecommendationCloneCard key={-1} data={this.state.mmidata}/>:"")
                        clonecards.push(this.state.niftyhasloaded?<RecommendationCloneCard key={-2} data={this.state.niftydata}/>:"")
                        clonecards.push(this.state.sensexhasloaded?<RecommendationCloneCard key={-3} data={this.state.sensexdata}/>:"")
                        return clonecards
                    })()}
                    {(() => {
                        if(this.state.filter === 2)return ""
                        return this.showRecommendations()
                    })()}
                </InfiniteScroll>
                    {/* <RecommendationCard name="Tata Consultancy Services" openedat={100} closedat={100} pointedprice={1268.20} indicatedprice={2.80} recommendationcount={91} graphdata={[1, 2, 13, 7, 22]}/>*/}
            </div>
            <div className="c_subcontainer_footer">
                
            </div>
        </div>
    }
    getMarketMoodIndex(){
        var marketmoodindex = axios.post(ApiHelper.scraper.getMarketMoodIndex)
        marketmoodindex.then(response => {
            const newstate = {...this.state}
            newstate.mmihasloaded = true
            newstate.mmidata = {
                name: "Market Sentiment",
                pointedprice: response.data.data,
                showinr: false,
                haschange: false,
                hasopenclose: false,
                hasfrontdescription: true,
                hasbackdescription: true,
                frontdescriptionheadercolor: (() => {
                    var mmi = parseInt(response.data.data)
                    if(mmi > 70) return "#FF5722"
                    else if(mmi > 50) return "#FFC107"
                    else if(mmi > 30) return "#8BC34A"
                    else return "#4CAF50"
                })(),
                frontdescriptionheader: (() => {
                    var mmi = parseInt(response.data.data)
                    if(mmi > 70) return "Extreme Greed"
                    else if(mmi > 50) return "Greed"
                    else if(mmi > 30) return "Fear"
                    else return "Extreme Fear"
                })(),
                frontdescription: (() => {
                    var mmi = parseInt(response.data.data)
                    if(mmi > 70) return "Markets are overbought and likely to turn downwards"
                    else if(mmi > 50) return "Action to be taken depends on the sentiment trajectory."
                    else if(mmi > 30) return "FearAction to be taken depends on the sentiment trajectory."
                    else return "Markets are likely to be oversold and might turn upwardsExtreme Fear"
                })(),
                backdescription: (() => {
                    var mmi = parseInt(response.data.data)
                    if(mmi > 70) return "High extreme greed (>80) suggests investors should avoid opening fresh positions as markets are overbought and likely to turn downwards"
                    else if(mmi > 50) return "If greed is increasing, investors should be cautious in opening new positions. If greed decreases from extreme greed, more patience is suggested before looking for fresh opportunities."
                    else if(mmi > 30) return "If fear is increasing, investors should wait till it reaches Extreme Fear, as that is when the market is expected to turn upwards. If fear is descreasing from extreme, might be a good time to open fresh positions."
                    else return "If sentiment is dropping from Greed to Fear, investors should wait till it reaches Extreme Fear, as that is when the market is expected to turn upwards. If sentiment is coming from Extreme fear, it might be a good time to open fresh positions."
                })(),
            }
            this.setState(newstate)
        }, error => {
            const newstate = {...this.state}
            newstate.mmihasloaded = false
            this.setState(newstate)
        })
    }
    getNifty(){
        var getnifty = axios.post(ApiHelper.scraper.getNifty)
        getnifty.then(response => {
            const newstate = {...this.state}
            newstate.niftyhasloaded = true
            newstate.niftydata = {
                name: "Nifty 50",
                pointedprice: response.data.data.nifty,
                showinr: true,
                haschange: true,
                hasopenclose: true,
                openedat: response.data.data.open,
                closedat: response.data.data.prevclose,
                change: response.data.data.change,
                hasfrontdescription: false,
                hasbackdescription: true,
                backdescription: "The NIFTY 50 is a benchmark Indian stock market index that represents the weighted average of 50 of the largest Indian companies listed on the National Stock Exchange. It is one of the two main stock indices used in India, the other being the BSE SENSEX."
            }
            this.setState(newstate)
        }, error => {
            const newstate = {...this.state}
            newstate.niftyhasloaded = false
            this.setState(newstate)
        })
    }
    getSensex(){
        var getsensex = axios.post(ApiHelper.scraper.getSensex)
        getsensex.then(response => {
            const newstate = {...this.state}
            newstate.sensexhasloaded = true
            newstate.sensexdata = {
                name: "Sensex",
                pointedprice: response.data.data.sensex,
                showinr: true,
                haschange: true,
                hasopenclose: true,
                openedat: response.data.data.open,
                closedat: response.data.data.prevclose,
                change: response.data.data.change,
                hasfrontdescription: false,
                hasbackdescription: true,
                backdescription: "The BSE SENSEX is a free-float market-weighted stock market index of 30 well-established and financially sound companies listed on Bombay Stock Exchange. The 30 constituent companies are representative of various industrial sectors of the Indian economy."
            }
            this.setState(newstate)
        }, error => {
            const newstate = {...this.state}
            newstate.sensexhasloaded = false
            this.setState(newstate)
        })
    }
    componentDidUpdate(prevProps, nextProps){

    }
    filterChangeHandler(event){
        const newstate = {...this.state}
        newstate[event.target.name] = parseInt(event.target.value)
        this.setState(newstate)
    }
    orderChangeHandler(event){
        const newstate = {...this.state}
        newstate.recommendationslist = []
        newstate.recommendationsoffset = 0
        newstate.hasMore = true
        newstate.isloadingfinished = false
        newstate[event.target.name] = parseInt(event.target.value)
        this.setState(newstate, () => {
            this.getrecommendations()
        })
    }
    componentDidMount(){
        this.getrecommendations()
        this.getMarketMoodIndex()
        this.getNifty()
        this.getSensex()
    }
    getrecommendations(){
        // console.log(`Offset is here ${this.state.recommendationsoffset}`)
        switch(this.state.sortby){
            case 0:
                axios.post(ApiHelper.companies.getArthSortedCompaniesByOffset, {offset: this.state.recommendationsoffset, filter: this.state.filter})
                .then(response => this.onRecommendationsReceived(response),
                error => this.onRecommendationsRejected(error))
                break
            case 1:
                axios.post(ApiHelper.companies.getRelevanceSortedCompaniesByOffset, {offset: this.state.recommendationsoffset, filter: this.state.filter})
                .then(response => this.onRecommendationsReceived(response),
                error => this.onRecommendationsRejected(error))
                break
            case 2:
                axios.post(ApiHelper.companies.getTargetDifferenceSortedCompaniesByOffset, {offset: this.state.recommendationsoffset, filter: this.state.filter})
                .then(response => this.onRecommendationsReceived(response),
                error => this.onRecommendationsRejected(error))
                break
            case 3:
                axios.post(ApiHelper.companies.getAlphabeticalSortedCompaniesByOffset, {offset: this.state.recommendationsoffset, filter: this.state.filter})
                .then(response => this.onRecommendationsReceived(response),
                error => this.onRecommendationsRejected(error))
                break
            default:
                axios.post(ApiHelper.getCompaniesByArthScore, {offset: this.state.recommendationsoffset, filter: this.state.filter})
                .then(response => this.onRecommendationsReceived(response),
                error => this.onRecommendationsRejected(error))
                break
        }
    }
    onRequireFetch(){
        // console.log(`I was here when isloadingfinished was ${this.state.isloadingfinished}`)
        if(this.state.isloadingfinished === true){
            const newstate = {...this.state}
            newstate.isloadingfinished = false
            newstate.recommendationsoffset = this.state.recommendationslist.length
            this.setState(newstate, () => {
                this.getrecommendations()
            })
        }
    }
    onRecommendationsReceived(response){
        try{
            const newstate = {...this.state}
            var recommendations = response.data.data
            // console.log("I was here")
            if(recommendations.length === 0){
                const newstate = {...this.state}
                newstate.hasMore = false
                this.setState(newstate)
                return
            }
            for(var i = 0; i < recommendations.length; i++){
                var recommendation = {}
                recommendation.serialid = recommendations[i].serial_id
                recommendation.company = recommendations[i].company
                recommendation.description = recommendations[i].description
                recommendation.symbol = recommendations[i].symbol
                recommendation.lastchecked = recommendations[i].lastchecked
                recommendation.relevance = recommendations[i].relevance
                recommendation.arthscore = recommendations[i].arthscore
                recommendation.targetdifference = recommendations[i].targetdifference
                recommendation.dailyhistory = recommendations[i].dailyhistory
                recommendation.targetprice = recommendations[i].targetprice
                recommendation.noofrecommendations = recommendations[i].noofrecommendations
                recommendation.recommender = recommendations[i].recommender
                recommendation.noofcompaniesbelow = recommendations[i].noofcompaniesbelow
                recommendation.minimumtargetprice = recommendations[i].minimumtargetprice
                recommendation.maximumtargetprice = recommendations[i].maximumtargetprice
                recommendation.brokerages = recommendations[i].brokerages
                newstate.recommendationslist.push(recommendation)
            }
            newstate.isloadingfinished = true
            this.setState(newstate)
        }catch(error){

        }
    }
    onRecommendationsRejected(error){
        alert(error.response.error_message || "An Error Occured")
    }
}
export default Recommendations